/* global localStorage */
function getTimestamp () {
  return localStorage.getItem('taurus.claims.store.timestamp')
}

function setTimestamp () {
  let now = new Date().getTime().toString()
  localStorage.setItem('taurus.claims.store.timestamp', now)
  return now
}

// Checks timestamp and version in localstorage and resets store if
// timestamp > 24hrs or version is different to env variable
function checkTimeStampAndVersion () {
  return new Promise((resolve, reject) => {
    let now = new Date().getTime().toString()
    let version = process.env.VUE_APP_VERSION
    let result = 'store not reset'
    if (((now - getTimestamp()) > 86400000) || (version !== getVersion())) {
      setStore()
      result = 'store reset'
    }
    setTimestamp()
    setVersion()

    resolve(result)
  })
}

function getVersion () {
  return localStorage.getItem('taurus.claims.version')
}

function setVersion () {
  localStorage.setItem('taurus.claims.version', process.env.VUE_APP_VERSION)
  return getVersion()
}

function getStore () {
  return localStorage.getItem('taurus.claims.store')
}

function setStore (json) {
  localStorage.setItem('taurus.claims.store', json)
}

function clearStore () {
  localStorage.setItem('taurus.claims.store', null)
}

function clear () {
  localStorage.clear()
}

export default {
  getTimestamp,
  setTimestamp,
  getVersion,
  setVersion,
  getStore,
  setStore,
  checkTimeStampAndVersion,
  clearStore,
  clear
}
